import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { IYouTubeConfigurationsModel, IGlobalConfigurationModel } from '../../models/global-setting/global-setting.model';
import { Helper } from '../helper.service';
@Injectable({
  providedIn: 'root',
})
export class GlobalSettingAPIService {
  constructor(
    private http: HttpClient,
    private helperService: Helper,
  ) {}
  options: any;
  private videoEndpoint = '';

  // public getVideoSetting(): Observable<IYouTubeConfigurationsModel> {
  //   return this.http.get(this.videoEndpoint) as Observable<IYouTubeConfigurationsModel>;
  // }
  // public updateVideoSetting(setting: IYouTubeConfigurationsModel): Observable<IYouTubeConfigurationsModel> {
  //   if (!setting) return;
  //   return this.http.put(this.videoEndpoint, setting) as Observable<IYouTubeConfigurationsModel>;
  // }

  public getGlobalConfiguration(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    if (!this.options) {
      return throwError(() => new Error('Options not set'));
    }
    return this.http.get(environment.globalConfigServiceEndPoint, this.options) as Observable<any>;
  }

  public getPublicGlobalConfiguration(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.get(environment.globalConfigServiceEndPoint + '/public', this.options) as Observable<any>;
  }

  public updateGlobalConfig(config: IGlobalConfigurationModel): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    return this.http.post(environment.globalConfigServiceEndPoint + '/', config, this.options).pipe(catchError(this.helperService.handleError));
  }
  public refreshVideos(): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };

    if (!this.options) {
      return throwError(() => new Error('Options not set'));
    }
    return this.http.get(environment.globalConfigServiceEndPoint + '/refreshVideos', this.options).pipe(catchError(this.helperService.handleError));
  }

  public testApiKey(apiKey: string, channelId: string, url: string): Observable<any> {
    this.options = { headers: this.helperService.getApiAuthHeader() };
    if (!this.options) {
      // Returning an empty observable if options are not set
      return throwError(() => new Error('Options not set'));
    }
    if (!apiKey || !url || !channelId) {
      return throwError(() => new Error('invalid input supplied'));
    }
    const request = {
      apiKey: apiKey,
      channelId: channelId,
      url: url,
    };

    return this.http.post(environment.globalConfigServiceEndPoint + '/validateYoutubeApiKey', request, this.options).pipe(catchError(this.helperService.handleError));
  }
}
